import axios from "axios";
// import { store } from "../state/store";
// import { setMSAADToken } from "../state/authSlice";

import { AAD_AUTH_TOKEN, TEAMS_AUTH_TOKEN } from "../constants/storageKeys"
import { debugLog, errorLog } from "../util/debug";


class MSGraphAPIClient {
    // constructor() {
    //     // this.state = store.getState();
    // }

    getAADToken = async (tenantId) => {
        // let token = localStorage.getItem(AAD_AUTH_TOKEN);
        // console.log('getAADToken(), stored token: ', token)
        let token = undefined

        if (!!!token) {
            const theURL = `${process.env.REACT_APP_BASE_URL || ''}/api/auth/token`;
            debugLog('tenant: ', tenantId)
            debugLog('Calling msgraph for auth token', theURL)

            const msTeamsAuthToken = window.localStorage.getItem(TEAMS_AUTH_TOKEN);
            try {
                const result = await axios.request({
                    method: "POST",
                    url: theURL,
                    data: {
                        authToken: msTeamsAuthToken,
                        tenantId
                    },
                    validateStatus: undefined,
                });

                debugLog('auth result', result)
                token = result.data.access_token;

                if (!!token) {
                    localStorage.setItem(AAD_AUTH_TOKEN, token);
                } else {
                    localStorage.removeItem(AAD_AUTH_TOKEN)
                }

            }
            catch (error) {
                errorLog('error getting auth token: ', error)
                alert(`getAADToken Error: ${error}`);
            }
        } else {
            errorLog('AAD token found in local storage')
        }
        return token;
    }

    getMemberList = async (aadToken, callerType, callerId, teamId = null) => {
        let fetchUrl;
        let resultSet = [];

        if (callerType === undefined) {
            return [200, resultSet];
        }

        debugLog('callerId    ', callerId)
        debugLog('teamId      ', teamId)

        if (callerType === 'chat') {
            fetchUrl = 'https://graph.microsoft.com/v1.0/chats/' + callerId + '/members';
        } else if (callerType === 'team') {
            fetchUrl = 'https://graph.microsoft.com/v1.0/teams/' + callerId + '/members';
        } else if (callerType === 'channel') {
            fetchUrl = 'https://graph.microsoft.com/v1.0/teams/' + teamId + '/channels/' + callerId + '/members'
        } else {
            fetchUrl = 'https://graph.microsoft.com/v1.0/users';
        }

        debugLog('url for member call ', fetchUrl)

        let response =  await fetch(fetchUrl, {
            method: 'GET',
            headers: { Authorization: 'Bearer ' + aadToken }
        })

        let body = await response.json()
        if (response.status === 200) {
            if (! ('value' in body)) {
                throw(new Error('unexpected response: ' + JSON.stringify(body)))
            }
            body.value.forEach(element => {
                resultSet.push(element);
            });            
        } else {
            console.error('Error in ms-graph call: ', response.status, JSON.stringify(body))
        }

        return [response.status, resultSet]
    }

    getConsentUrl = (tenantId) => {
        let tenantStr = 'common'
        if (!!tenantId) {
            tenantStr = tenantId;
        }
        const url =  `https://login.microsoftonline.com/${tenantStr}/adminconsent?client_id=${process.env.REACT_APP_CLIENT_ID}&state=12345&redirect_uri=${process.env.REACT_APP_BASE_URL}/auth-end.html`
        debugLog('consent url: ', url)
        return url
    }
};

export default MSGraphAPIClient;